import React from 'react';

const SvgIconMotorcycleOn = props => (
  <svg width={155} height={88} viewBox="0 0 155 88" {...props}>
    <defs>
      <linearGradient
        id="icon-motorcycle-on_svg__a"
        x1="18.781%"
        x2="68.969%"
        y1="15.134%"
        y2="105.134%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__b"
        x1="21.611%"
        x2="79.433%"
        y1="4.73%"
        y2="89.402%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__c"
        x1="30.357%"
        x2="82.407%"
        y1="15.086%"
        y2="86.184%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__d"
        x1="42.736%"
        x2="57.171%"
        y1="21.32%"
        y2="79.674%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__e"
        x1="38.228%"
        x2="75.338%"
        y1="24.141%"
        y2="80.582%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__f"
        x1="30.495%"
        x2="75.194%"
        y1="2.794%"
        y2="84.934%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__g"
        x1="34.423%"
        x2="66.19%"
        y1="44.416%"
        y2="62.831%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__h"
        x1="48.29%"
        x2="51.66%"
        y1="47.85%"
        y2="52.717%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__i"
        x1="48.84%"
        x2="50.61%"
        y1="48.583%"
        y2="51.15%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__j"
        x1="33.31%"
        x2="81.018%"
        y1="15.462%"
        y2="99.747%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__k"
        x1="26.231%"
        x2="73.785%"
        y1="6.692%"
        y2="93.317%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__l"
        x1="32.575%"
        x2="48.523%"
        y1="19.365%"
        y2="58.935%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__m"
        x1="35.189%"
        x2="53.47%"
        y1="36.212%"
        y2="49.22%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__n"
        x1="23.586%"
        x2="75.648%"
        y1="1.907%"
        y2="96.743%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__o"
        x1="32.682%"
        x2="63.33%"
        y1="43.331%"
        y2="62.933%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__p"
        x1="24.99%"
        x2="74.979%"
        y1="6.782%"
        y2="93.233%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__q"
        x1="25.018%"
        x2="75.007%"
        y1="6.782%"
        y2="93.233%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__r"
        x1="32.363%"
        x2="66.529%"
        y1="35.214%"
        y2="58.399%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__s"
        x1="42.65%"
        x2="65.982%"
        y1="27.431%"
        y2="70.122%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__t"
        x1="43.346%"
        x2="65.294%"
        y1="35.497%"
        y2="57.945%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__u"
        x1="43.356%"
        x2="57.465%"
        y1="46.215%"
        y2="53.489%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__v"
        x1="16.946%"
        x2="70.394%"
        y1="27.872%"
        y2="74.511%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__w"
        x1="19.702%"
        x2="84.408%"
        y1="-3.26%"
        y2="106.36%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__x"
        x1="-12.68%"
        x2="112.798%"
        y1="50.13%"
        y2="50.13%"
      >
        <stop offset="0%" stopOpacity={0} />
        <stop offset="100%" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__y"
        x1="9.07%"
        x2="71.5%"
        y1="-4.862%"
        y2="94.684%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__z"
        x1="24.815%"
        x2="164.403%"
        y1="6.696%"
        y2="248.096%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__A"
        x1="24.608%"
        x2="74.243%"
        y1="6.5%"
        y2="92.353%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__B"
        x1="24.863%"
        x2="74.548%"
        y1="7.389%"
        y2="93.32%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__C"
        x1="24.689%"
        x2="74.324%"
        y1="7.674%"
        y2="93.527%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__D"
        x1="21.682%"
        x2="63.354%"
        y1="14.172%"
        y2="87.919%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__E"
        x1="38.519%"
        x2="60.629%"
        y1="23.86%"
        y2="79.012%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__F"
        x1="24.632%"
        x2="74.492%"
        y1="18.806%"
        y2="80.438%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__G"
        x1="39.912%"
        x2="57.247%"
        y1="11.649%"
        y2="81.766%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__H"
        x1="49.349%"
        x2="50.112%"
        y1="30.335%"
        y2="61.052%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__I"
        x1="33.587%"
        x2="69.887%"
        y1=".112%"
        y2="87.344%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__J"
        x1="24.038%"
        x2="70.896%"
        y1="27.249%"
        y2="74.203%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__K"
        x1="35.963%"
        x2="64.05%"
        y1="47.91%"
        y2="52.014%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__L"
        x1="18.681%"
        x2="79.06%"
        y1="4.82%"
        y2="110.848%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__M"
        x1="39.944%"
        x2="69.673%"
        y1="24.197%"
        y2="98.672%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__N"
        x1="47.4%"
        x2="51.557%"
        y1="12.196%"
        y2="87.33%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__O"
        x1="38.968%"
        x2="66.56%"
        y1="27.407%"
        y2="59.428%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__P"
        x1="40.277%"
        x2="81.398%"
        y1="8.295%"
        y2="95.458%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__Q"
        x1="47.61%"
        x2="53.76%"
        y1="46.649%"
        y2="55.785%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__R"
        x1="25.034%"
        x2="75.291%"
        y1="6.709%"
        y2="93.622%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__S"
        x1="25.605%"
        x2="75.026%"
        y1="7.592%"
        y2="93.065%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__T"
        x1="37.859%"
        x2="56.365%"
        y1="20.646%"
        y2="80.377%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__U"
        x1="36.585%"
        x2="64.279%"
        y1="46.449%"
        y2="55.34%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__V"
        x1="27.257%"
        x2="77.449%"
        y1="21.249%"
        y2="82.178%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__W"
        x1="32.49%"
        x2="60.905%"
        y1="16.271%"
        y2="79.499%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__X"
        x1="42.896%"
        x2="66.036%"
        y1="27.869%"
        y2="67.887%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__Y"
        x1="43.855%"
        x2="66.385%"
        y1="27.2%"
        y2="66.17%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__Z"
        x1="25.25%"
        x2="75.412%"
        y1="6.43%"
        y2="93.171%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aa"
        x1="25.079%"
        x2="75.579%"
        y1="6.383%"
        y2="93.722%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ab"
        x1="25.092%"
        x2="75.592%"
        y1="5.779%"
        y2="93.117%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ac"
        x1="25.145%"
        x2="75.645%"
        y1="6.278%"
        y2="93.617%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ad"
        x1="24.289%"
        x2="74.789%"
        y1="6.41%"
        y2="93.748%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ae"
        x1="24.711%"
        x2="75.211%"
        y1="6.423%"
        y2="93.761%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__af"
        x1="25.462%"
        x2="75.625%"
        y1="7.116%"
        y2="93.857%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ag"
        x1="24.625%"
        x2="74.775%"
        y1="6.343%"
        y2="93.083%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ah"
        x1="25.462%"
        x2="75.625%"
        y1="6.592%"
        y2="93.333%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ai"
        x1="23.722%"
        x2="74.605%"
        y1="6.566%"
        y2="93.057%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aj"
        x1="39.644%"
        x2="57.671%"
        y1="21.962%"
        y2="80.703%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ak"
        x1="40.568%"
        x2="68.048%"
        y1="13.686%"
        y2="91.022%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__al"
        x1="25.052%"
        x2="75.101%"
        y1="6.698%"
        y2="93.254%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__am"
        x1="26.014%"
        x2="75.116%"
        y1="30.132%"
        y2="76.897%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__an"
        x1="25.03%"
        x2="73.69%"
        y1="17.703%"
        y2="78.342%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ao"
        x1="37.577%"
        x2="61.491%"
        y1="42.148%"
        y2="57.323%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ap"
        x1="33.501%"
        x2="66.166%"
        y1="22.001%"
        y2="67.553%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aq"
        x1="32.271%"
        x2="67.849%"
        y1=".92%"
        y2="97.302%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ar"
        x1="38.034%"
        x2="61.741%"
        y1="27.527%"
        y2="74.928%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__as"
        x1="36.455%"
        x2="64.541%"
        y1="14.987%"
        y2="80.017%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__at"
        x1="38.776%"
        x2="66.242%"
        y1="43.251%"
        y2="56.886%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__au"
        x1="28.428%"
        x2="72.844%"
        y1="6.465%"
        y2="87.316%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__av"
        x1="41.064%"
        x2="59.399%"
        y1="41.722%"
        y2="56.376%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aw"
        x1="37.999%"
        x2="58.707%"
        y1="16.98%"
        y2="72.987%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ax"
        x1="33.167%"
        x2="66.196%"
        y1="10.302%"
        y2="97.598%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__ay"
        x1="22.413%"
        x2="77.044%"
        y1="7.815%"
        y2="91.796%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__az"
        x1="2.724%"
        x2="72.586%"
        y1="7.016%"
        y2="92.037%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aA"
        x1="28.343%"
        x2="65.722%"
        y1="35.457%"
        y2="63.737%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aB"
        x1="31.161%"
        x2="82.072%"
        y1="-.432%"
        y2="87.573%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aC"
        x1="47.61%"
        x2="53.76%"
        y1="46.096%"
        y2="56.74%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aD"
        x1="48.418%"
        x2="51.424%"
        y1="10.334%"
        y2="90.683%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aE"
        x1="21.381%"
        x2="64.732%"
        y1="12.653%"
        y2="78.87%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aF"
        x1="24.895%"
        x2="74.536%"
        y1="25.014%"
        y2="75.994%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aG"
        x1="24.954%"
        x2="75.196%"
        y1="6.655%"
        y2="93.548%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aH"
        x1="24.94%"
        x2="75.181%"
        y1="6.6%"
        y2="93.493%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aI"
        x1="38.39%"
        x2="60.66%"
        y1="19.567%"
        y2="82.351%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aJ"
        x1="41.993%"
        x2="62.228%"
        y1="27.739%"
        y2="83.22%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aK"
        x1="28.127%"
        x2="74.21%"
        y1="24.676%"
        y2="74.98%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aL"
        x1="41.448%"
        x2="52.564%"
        y1="10.253%"
        y2="84.34%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aM"
        x1="36.058%"
        x2="64.217%"
        y1="45.721%"
        y2="53.582%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aN"
        x1="15.577%"
        x2="65.129%"
        y1="22.462%"
        y2="83.746%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aO"
        x1="25.007%"
        x2="75.061%"
        y1="6.701%"
        y2="93.261%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aP"
        x1="25.095%"
        x2="75.063%"
        y1="6.749%"
        y2="93.165%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aQ"
        x1="28.353%"
        x2="72.756%"
        y1="29.03%"
        y2="68.879%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aR"
        x1="25.302%"
        x2="74.823%"
        y1="7.649%"
        y2="93.287%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aS"
        x1="25.521%"
        x2="75.042%"
        y1="7.337%"
        y2="92.965%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aT"
        x1="25.074%"
        x2="75.019%"
        y1="6.843%"
        y2="93.219%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aU"
        x1="24.977%"
        x2="75.203%"
        y1="6.626%"
        y2="93.487%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aV"
        x1="25.286%"
        x2="75.024%"
        y1="7.09%"
        y2="93.108%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aW"
        x1="31.205%"
        x2="77.634%"
        y1="12.404%"
        y2="88.894%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aX"
        x1="25.582%"
        x2="75.112%"
        y1="7.301%"
        y2="92.954%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-on_svg__aY"
        x1="19.101%"
        x2="78.311%"
        y1="9.301%"
        y2="91.128%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="url(#icon-motorcycle-on_svg__a)"
        fillRule="nonzero"
        d="M60.495 64.533l-2.957 5.387 6.155 2.827.89-1.863z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__b)"
        fillRule="nonzero"
        d="M49.953 60.453l1.33-.093c-.34-.648-.783-1.985-.783-1.985-.287.172-1.004-.132-1.004-.132s-2.841-5.916-4.25-7.213c-1.407-1.297 0 0 0 0l.692-.133s2.463 3.203 3.637 6.485c0 0 .182.583.808.583 0 0 5.37.026 5.748 0 .365-.027.3-.159.3-.159s.209.741 1.303.741c0 0-.039.291-.09.45 0 0 .482.199 1.068.172 0 0-.339.887-.339 1.893l-8.095 1.125c-.013-.027-.143-1.06-.325-1.734z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__c)"
        fillRule="nonzero"
        d="M46.97 50.52s2.367 3.07 3.59 6.399a.86.86 0 0 0 .798.574h5.559a.617.617 0 0 0 .605-.757l-.991-4.531-4.697-2.925-4.864 1.24"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__d)"
        fillRule="nonzero"
        d="M106.36 41.815s.697-1.093.439-1.704c-.259-.61-1.072-.993-1.072-.993l.503-1.306a.33.33 0 0 0-.09-.37l-.413-.326.516-1.263c.052-.142.013-.312-.103-.397l-.361-.256-8.317 18.694s.982.781 1.214 1.108c.245.326 0 0 0 0l6.315-14.153 1.369.966"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__e)"
        fillRule="nonzero"
        d="M88.39 36.373c-1.418 0-2.945.662-3.161.759-.23.193-.473.413-.73.648L62.585 58.24c-1.621 1.517-2 3.985-.892 5.943l4.297 7.542.445.042c.068-.497.46-.883.96-.938l-2.31-4.26a1.028 1.028 0 0 1-.811-.11 1.109 1.109 0 0 1-.54-.718c-.163-.73.378-1.379 1.067-1.379.405 0 .77.235.959.566l10.444 4.66s-.014 0-.014.014c.243-.22.46-.386.595-.4.419-.069 3.215.938 3.553 1.765.122.303.122.58.04.813h.244c-.108-.523-.203-1.047-.216-1.254-.054-.483-.136-.634 0-.69.135-.069 1.445.097 1.918.166.473.069.838.345 1.58.358.73.014 1.041-.413 1.528-.73.486-.318.648-.373 1.067-.414.419-.041.608.11.675.538.055.33-1.62 2.426-3.701 2.399 0 0 .797.096 1.553.593a68.91 68.91 0 0 0 2.702-.11l.365-.91-.148-.456.54-.565h.405l.135-.62s.608.055.892 0c.27-.056.446-.166.473-.331.027-.166-.297-.635-.297-.635h3.229l1.027-2.192v-.014c0-1.117-.149-1.765-.176-1.985-.04-.22-.486-.207-.486-.207.77-3.475 3.431-4.702 3.431-4.702.325-.924.581-1.723.635-2.137.149-1.255-.891-2.385-.891-2.385l-1.865 3.874s-.175-.041-.432-.138a.966.966 0 0 0-.54-.234 3.771 3.771 0 0 1-.555-.345s4.662-9.996 5.702-12.12c1.04-2.123 2.364-4.674 3.864-7.666.095-.193.203-.4.297-.62-.054 0-14.267-1.876-14.943-1.876zm-4.107 13.761l-.446.22-.027-.565c-.81-.165-2.08-.11-2.513-.11-.432 0-1.31.207-2.013.124-.702-.083-1.216-.29-1.932-.234-.716.069-1.608 1.516-1.608 1.516-1.31-.896-3.107-1.737-3.107-1.737.108-.317 1.148-.69 1.148-.69l.108.552s.933 0 1.527-.069c.595-.069 1.608-.882 1.608-.882l3.418-.373.865-.537h1.31l.284.51 1.378.579.378-.055.068.441-.446 1.31zm15.835-5.502L98.09 46.59l-.027-2.178-1.202-1.944-.487-.193s.338-1.53.595-2.524c.256-.979 0-1.489 0-1.489v-.827l3.404.441-.256 6.756z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__f)"
        fillRule="nonzero"
        d="M98.636 45.258l-1.525-.55a1.832 1.832 0 0 0-1.78-2.273c-.72 0-1.342.423-1.653 1.03l-3.546-1.299c.029-.141.057-.282.057-.438 0-1.016-.82-1.835-1.837-1.835-.72 0-1.342.41-1.638 1.017l-1.483-.537s-.17.254 0 .466l-.777 3.416.861 3.19s-.282.24-.127.551l-.438 1.468-1.497-.522a.153.153 0 0 0-.198.099l-.155.593-1.597-.579-1.2.014-.255.678 1.003.762 1.441.579.085.494 1.723.508.029 1.115-.636 1.906s.141.65.085 1.299l.41.41.197.112c.057-.014.113-.028.17-.028.099 0 .198.028.282.07.127-.014.255-.014.396-.014 1.229 0 2.33.48 3.15 1.27.042-.013.07-.013.113-.013a.567.567 0 0 1 .523.776c.17.254.31.522.423.805l.071.042.989-1.61a1.08 1.08 0 0 1 .494-.409l1.512-.564-1.243-.297 3.178-4.87.212-.325s.226-.042.31-.197c.1-.198.029-.34.029-.34l3.842-5.97z"
      />
      <g fillRule="nonzero">
        <path
          fill="url(#icon-motorcycle-on_svg__g)"
          d="M1.624 4.143c.523.077 14.66 1.73 15.099 1.781l.353-.761c-.014-.065-.084-.271-.466-.555-.467-.336-6.235-4.143-6.532-4.311-.297-.168-.848-.194-1.3-.103l-7.41 3.252c.014.013-.269.62.255.697z"
          transform="translate(88.068 31.68)"
        />
        <path
          fill="url(#icon-motorcycle-on_svg__h)"
          d="M16.483 6.428l.07-.13z"
          transform="translate(88.068 31.68)"
        />
        <path
          fill="url(#icon-motorcycle-on_svg__i)"
          d="M1.355 3.459l-.608.271v.013z"
          transform="translate(88.068 31.68)"
        />
      </g>
      <path
        fill="url(#icon-motorcycle-on_svg__j)"
        fillRule="nonzero"
        d="M102.501 26.987l1.977 4.09c.04.068.04.163 0 .231l-1.23 2.645c-.026.068-.12.095-.173.054-.748-.545-4.834-3.503-5.128-3.68-.561-.355-.48-.86-.48-.86"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__k)"
        fillRule="nonzero"
        d="M132.69 42.24c-12.327 0-22.311 10.24-22.311 22.88 0 12.64 9.984 22.88 22.31 22.88C145.015 88 155 77.76 155 65.12c0-12.64-9.985-22.88-22.31-22.88zm0 37.839c-8.047 0-14.587-6.693-14.587-14.959 0-8.252 6.526-14.959 14.586-14.959s14.587 6.693 14.587 14.959-6.526 14.959-14.587 14.959z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__l)"
        fillRule="nonzero"
        d="M119.773 49.47s-.631-1.426-1.223-2.312c-.49-.72-.837-1.107-.953-1.398-4.235 3.35-7.298 8.318-8.392 14.062 1.905.222 2.651-1.702 2.651-1.702a23.369 23.369 0 0 1 4.905-7.626c.592-.61 1.519-.679 2.175-.153l.45.36.335-.166c-.193-.25-.322-.72.052-1.066z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__m)"
        fillRule="nonzero"
        d="M130.691 41.067c-3.487 0-6.78.793-9.744 2.195.276.312.786.963 1.006 1.785.303 1.147.524 1.445.992 2.351 0 0 .373-.226.758-.141.359.07.607.467.552.85l.262-.128.096-1.558a1.82 1.82 0 0 1 1.31-1.671 22.587 22.587 0 0 1 6.215-.865c.868 0 1.723.057 2.564.142 3.514.128 3.859-1.544 3.859-1.558a22.638 22.638 0 0 0-7.87-1.402z"
      />
      <path
        fill="#F96D67"
        fillRule="nonzero"
        d="M33.977 36.062v-.023a.526.526 0 0 0-.529-.528.536.536 0 0 0-.493.34c.364.07.705.141 1.022.211z"
      />
      <path
        fill="#AF0000"
        fillRule="nonzero"
        d="M17.514 36.866a.545.545 0 0 0-.446-.246.526.526 0 0 0-.529.528c0 .058.012.105.024.152.317-.152.634-.293.95-.434z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__n)"
        fillRule="nonzero"
        d="M27.008 42.24c-12.326 0-22.311 10.24-22.311 22.88 0 12.64 9.985 22.88 22.31 22.88 12.327 0 22.311-10.24 22.311-22.88 0-12.64-9.998-22.88-22.31-22.88zm0 37.839c-8.047 0-14.587-6.693-14.587-14.959 0-8.252 6.526-14.959 14.587-14.959 8.06 0 14.586 6.693 14.586 14.959-.013 8.266-6.54 14.959-14.586 14.959z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__o)"
        fillRule="nonzero"
        d="M41.419 44.038c-1.226-.752-4.17-5.74-4.564-7.12 0 0-6.472-2.706-14.21-1.326-7.52 1.353-14.347 7.025-16.745 12.109-.095.191.055.423.273.423 1.213-.013 4.687-.054 8.801-.191.164 0 .327-.055.477-.137.9-.519 4.55-2.432 9.469-2.432 5.518 0 10.327 2.05 15.354 5.658.777.56 1.744.738 2.67.505l7.548-1.913c-4.455-2.733-8.692-5.344-9.073-5.576z"
      />
      <ellipse
        cx={27.595}
        cy={66.293}
        fill="url(#icon-motorcycle-on_svg__p)"
        fillRule="nonzero"
        rx={14.678}
        ry={14.667}
      />
      <ellipse
        cx={132.102}
        cy={66.293}
        fill="url(#icon-motorcycle-on_svg__q)"
        fillRule="nonzero"
        rx={14.678}
        ry={14.667}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__r)"
        fillRule="nonzero"
        d="M65.011 39.998s.719-.845.746-1.17c.014-.17-.244-.897-1.709-1.261-1.479-.364-5.277.299-6.212.39-.923.09-6.321.195-9.36-.95-3.038-1.143-6.05-3.08-7.23-2.976-1.18.104-1.424 1.066-1.288 2.132.136 1.066 3.282 5.291 5.724 6.838 2.442 1.547 3.649 1.95 6.89 1.261 3.242-.689 9.536-2.782 9.536-2.782s1.343-.455 1.872-.663c.53-.208 1.031-.819 1.031-.819z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__s)"
        fillRule="nonzero"
        d="M106.462 23.467L87.2 33.189a8.785 8.785 0 0 0-2.087 1.457L61.99 56.208a6.667 6.667 0 0 0-1.242 8.141l5.43 9.571s.886-.11 1.718-.908L62.4 63.428c-1.105-1.912-.723-4.346.887-5.844l22.371-20.655a15.873 15.873 0 0 1 3.875-2.64l18.497-8.966"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__t)"
        fillRule="nonzero"
        d="M50.492 47.074l12.518 8.073L79.848 38.72z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__u)"
        fillRule="nonzero"
        d="M81.023 37.547l-31.705 8.616 1.26.77 28.734-7.79z"
      />
      <ellipse cx={33.466} cy={45.173} fill="#AF0000" fillRule="nonzero" rx={1} ry={1} />
      <ellipse cx={20.549} cy={45.173} fill="#AF0000" fillRule="nonzero" rx={1} ry={1} />
      <path
        fill="#AF0000"
        fillRule="nonzero"
        d="M33.977 36.062v-.023a.526.526 0 0 0-.529-.528.536.536 0 0 0-.493.34c.364.07.705.141 1.022.211zm-16.463.804a.545.545 0 0 0-.446-.246.526.526 0 0 0-.529.528c0 .058.012.105.024.152.317-.152.634-.293.95-.434z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__v)"
        fillRule="nonzero"
        d="M8.752 41.857s.076-.487.29-.742c.215-.243.629-.614.077-1.471-.551-.857-2.328-2.085-4.151-2.097-1.425-.012-2.237.336-2.512.475a.178.178 0 0 0-.108.162c.062.556.322 3.22.368 3.464.061.278.613.614 1.149.59.536-.022 1.011-.335 1.41-.405.398-.07.765 0 .765 0l.016.278"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__w)"
        fillRule="nonzero"
        d="M3.218 37.547l-3.084.226c-.073 0-.134.06-.134.144 0 .465.024 2.135.256 2.9.049.154.195.25.353.25l2.914-.072-.305-3.448z"
      />
      <path
        stroke="url(#icon-motorcycle-on_svg__x)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M56.364 54.56h-8.22"
        opacity={0.5}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__y)"
        fillRule="nonzero"
        d="M58.82 58.667h-1.333c-.44 0-1.135-.092-1.418-.732 0 0 .297-.248.212-.601L55.19 52.8l5.872 3.319c-.015 0-1.575 1.15-2.241 2.548z"
      />
      <ellipse
        cx={51.08}
        cy={51.04}
        fill="url(#icon-motorcycle-on_svg__z)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={51.08}
        cy={51.04}
        fill="url(#icon-motorcycle-on_svg__A)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={45.208}
        cy={48.693}
        fill="url(#icon-motorcycle-on_svg__B)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={45.208}
        cy={49.867}
        fill="url(#icon-motorcycle-on_svg__C)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__D)"
        fillRule="nonzero"
        d="M41.699 55.22l2.823 2.476c.12.11.134.3.027.424l-1.405 1.642a2.295 2.295 0 0 1-1.057.697l-1.58.493c-1.016.314-1.98-.63-1.712-1.67l.295-1.176c.08-.328.24-.63.455-.875l1.726-1.97c.12-.137.307-.15.428-.041z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__E)"
        fillRule="nonzero"
        d="M31.705 58.961l6.443-9.681 1.776 1.414-6.088 9.146z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__F)"
        fillRule="nonzero"
        d="M37.616 47.83c.29.345 1.508 1.481 4.012 2.605.07.038.153.013.208-.037l1.508-1.58a.358.358 0 0 0 .028-.47c-.457-.556-1.73-1.915-3.944-2.57a.448.448 0 0 0-.484.149l-1.314 1.741c-.07.038-.07.1-.014.161z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__G)"
        fillRule="nonzero"
        d="M41.394 45.76l-.094-.796a2.187 2.187 0 0 1 .165-1.139l.176-.412.446.343-.223.508c-.07.151-.094.316-.094.48v.412l-.376.604z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__H)"
        fillRule="nonzero"
        d="M50.452 65.99a1.952 1.952 0 0 1-.41-.195l-2.319-1.483a2.215 2.215 0 0 0-.396-.195l-15.583-5.45s-.887 3.941-2.388 7.375l15.938 3.812c.123.026.26.052.396.052l3.37.117c.178 0 .355.039.533.09l.9.287c.682-.924 1.174-3.993 1.174-3.993l-1.215-.417z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__I)"
        fillRule="nonzero"
        d="M30.798 58.672l-4.365.295c-.114.014-.213.084-.241.197-.369 1.546-.369 4.849-.354 5.692 0 .127.07.239.17.31l2.692 1.56a.63.63 0 0 0 .227.084l.298.07c1.544-3.71 2.48-7.97 2.48-7.97l-.553-.196a.749.749 0 0 0-.354-.042z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__J)"
        fillRule="nonzero"
        d="M50.609 70.35c.414.45 6.623 2.509 7.063 2.609.44.1 1.099.137 1.099.137l2.225.824c.44-.162.828-.624 1.112-1.323.285-.7 0-1.323 0-1.323l-2.25-.886s-.285-.4-.932-.712c-.646-.312-5.045-2.035-5.691-2.334-.647-.3-1.617-.462-1.617-.462s-.453 2.634-1.126 3.67"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__K)"
        fillRule="nonzero"
        d="M49.318 65.891s11.256-.012 11.27 0l.473.704-9.283.106-1.015-.2-.013-.164-1.307-.399-.125-.047z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__L)"
        fillRule="nonzero"
        d="M52.84 65.695c.323-.372.079-1.026.079-1.026l.956-.136s.2.62.122 1.174l-1.156-.012z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__M)"
        fillRule="nonzero"
        d="M117.957 43.645s-.533.62-.533.93c0 .31.424.687 1.052 1.536.628.863 1.297 2.25 1.297 2.25-.574.5-.027 1.227.232 1.187.26-.04.546 0 .806.161.26.162 10.268 16.804 10.473 17.074.205.27.805 1.67 1.72 1.159.915-.499 1.461-.701 1.803-.97.341-.27.273-1.038 0-1.429-.273-.404-9.559-15.497-9.9-16.117a35.369 35.369 0 0 1-.724-1.415c.055-.296.355-.458.492-.862.123-.39-.15-.836-.533-.916-.382-.081-.75.134-.75.134-.465-.862-.67-1.145-.984-2.237-.3-1.091-1.174-1.873-1.174-1.873-.369-.08-.874.149-.874.149l.068.12s-.915.863-2.39 1.24l-.081-.12z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__N)"
        fillRule="nonzero"
        d="M117.47 18.773s.834.64 1.045 3.775c.212 3.134-.517 6.268-1.021 6.785l-.024-10.56z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__O)"
        fillRule="nonzero"
        d="M113.902 31.453l2.508-2.12s.501.123.927.136c.41.014 1.261.014 1.261.014l-3.815 3.37-.881-1.4z"
      />
      <g fillRule="nonzero">
        <path
          fill="url(#icon-motorcycle-on_svg__P)"
          d="M.282 4.398s1.49-2.51 3.865-3.702L7.93.435c.215-.013.416.136.43.348l.013 10.088s-.738 0-1.114-.013a4.551 4.551 0 0 1-.818-.124l-.457.397-1.69-.062s-.685-.037-1.141-.174L.55 6.597s.403-.857.363-1.13c-.054-.311-.631-1.07-.631-1.07z"
          transform="translate(109.205 17.6)"
        />
        <path
          fill="url(#icon-motorcycle-on_svg__Q)"
          d="M8.36 10.858l-.362.336c.188-.013.35-.15.363-.336z"
          transform="translate(109.205 17.6)"
        />
      </g>
      <ellipse
        cx={93.939}
        cy={59.84}
        fill="url(#icon-motorcycle-on_svg__R)"
        fillRule="nonzero"
        rx={1.174}
        ry={1.173}
      />
      <ellipse
        cx={93.352}
        cy={59.253}
        fill="url(#icon-motorcycle-on_svg__S)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__T)"
        fillRule="nonzero"
        d="M105.388 26.774l1.599 3.073s-1.951 5.74-3.455 8.677c-1.504 2.938-2.832 5.442-3.875 7.527-1.043 2.084-5.718 11.898-5.718 11.898.177.136.366.244.556.352.203.027.393.108.542.23.257.095.433.136.433.136s7.588-15.46 8.157-16.623c.569-1.15 2.208-4.4 2.832-5.726.623-1.327 2.181-5.009 2.181-5.009l1.41 2.68s.961-.297 1.503-.798l-4.146-7.378-2.019.961z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__U)"
        fillRule="nonzero"
        d="M85.72 36.464s1.67-.759 3.23-.759c.683 0 15.133 1.842 15.133 1.842l.425-.92S90.4 34.838 89.88 34.756c-.52-.08-.233-.73-.233-.73l-1.286.636a11.645 11.645 0 0 0-2.641 1.8z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__V)"
        fillRule="nonzero"
        d="M96.288 31.396c.42-.09.932-.064 1.208.103.276.168 5.633 3.972 6.066 4.307.433.335.447.567.447.567l.499-1.212s-.355-.025-.84-.36l-5.148-3.546s-.354-.181-.38-.748l-1.852.89z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__W)"
        fillRule="nonzero"
        d="M93.94 53.34l-2.801 4.141s-.312.048-.722-.048l1.083-2.832c.112-.289.236-.553.386-.829l.535-.972 1.518.54z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__X)"
        fillRule="nonzero"
        d="M83.026 50.804s-.364-.082-.458.082c-.082.164.059.305.059.305l.282.106.117-.493z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__Y)"
        fillRule="nonzero"
        d="M80.67 50.76s-.388-.046-.458.153c-.07.2.246.411.246.411l.212-.563z"
      />
      <ellipse
        cx={89.83}
        cy={62.773}
        fill="url(#icon-motorcycle-on_svg__Z)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={82.784}
        cy={55.733}
        fill="url(#icon-motorcycle-on_svg__aa)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={80.436}
        cy={52.213}
        fill="url(#icon-motorcycle-on_svg__ab)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={76.913}
        cy={51.04}
        fill="url(#icon-motorcycle-on_svg__ac)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={72.216}
        cy={52.213}
        fill="url(#icon-motorcycle-on_svg__ad)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={68.693}
        cy={55.733}
        fill="url(#icon-motorcycle-on_svg__ae)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={88.655}
        cy={59.253}
        fill="url(#icon-motorcycle-on_svg__af)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={83.958}
        cy={58.08}
        fill="url(#icon-motorcycle-on_svg__ag)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={86.307}
        cy={66.293}
        fill="url(#icon-motorcycle-on_svg__ah)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ai)"
        fillRule="nonzero"
        d="M88.84 62.174c.13 0 .247.05.337.127a4.023 4.023 0 0 0-.636-2.984.516.516 0 0 1-1-.179.5.5 0 0 1 .416-.497 4.21 4.21 0 0 0-2.909-1.148c-.117 0-.247 0-.363.013.155.09.272.255.272.446 0 .281-.233.51-.52.51a.516.516 0 0 1-.519-.51c0-.127.052-.255.13-.344a4.274 4.274 0 0 0-1.558.74c.026.191.026.395.026.6a5.548 5.548 0 0 1-1.493 3.8c.506 1.709 2.116 2.959 4.012 2.959.208 0 .403-.013.598-.039a.513.513 0 0 1-.104-.306c0-.28.233-.51.519-.51.286 0 .52.23.52.51v.064a4.227 4.227 0 0 0 2.324-2.219c-.026 0-.052.013-.065.013a.516.516 0 0 1-.52-.51.541.541 0 0 1 .533-.536z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aj)"
        fillRule="nonzero"
        d="M88.068 75.093s3.754-.298 5.488-2.396c1.748-2.098 5.36-10.614 5.916-12.564.543-1.936.35-3.614 0-4.346-.35-.73-1.8-1.814-1.8-1.814l-.802 1.72s.997 1.096.854 2.342c-.142 1.245-1.98 5.713-2.485 6.959-.505 1.245-1.993 5.388-3.585 6.647-1.592 1.26-3.418.988-3.418.988s.337 1.449-.168 2.464z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ak)"
        fillRule="nonzero"
        d="M103.693 21.12s-1.043.494-1.534 1.04l.54 1.207.37-.156.145.26s-.348.22-.24.494c.108.272.443.065.443.065l.276.61.767-.416s-.384-.844.048-1.428l-.815-1.676z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__al)"
        fillRule="nonzero"
        d="M81.636 57.993c.174-.133.36-.253.561-.36a6.455 6.455 0 0 0-2.965-4.992h-.014c-.2 0-.36-.107-.454-.28a6.349 6.349 0 0 0-2.551-.734.51.51 0 0 1-.468.32.496.496 0 0 1-.467-.32 6.462 6.462 0 0 0 .467 12.906 6.412 6.412 0 0 0 4.448-1.775c-.013-.053-.04-.12-.053-.173a5.925 5.925 0 0 0 1.536-3.978c0-.2-.013-.414-.04-.614z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__am)"
        fillRule="nonzero"
        d="M79.646 72.078s1.222.82 1.337 1.033c.158.32-.187.593-.475.712-.287.119-1.51.095-1.51.095h-1.394c-.417 0-.777-.154-.92-.285 0 0-.36.06-.907-.297-.546-.356-1.61-1.103-1.725-1.436-.115-.332-.115-.736.13-.985.244-.25 1.754-1.626 2.2-1.685.445-.06 3.422.807 3.781 1.519.302.593-.086 1.056-.517 1.33z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__an)"
        fillRule="nonzero"
        d="M74.815 70.868c-.101-.365-.101-.81.114-1.084.153-.195.85-.992 1.397-1.475l-9.813-4.414a1.01 1.01 0 0 0-.901-.535c-.572 0-1.029.47-1.029 1.058 0 .587.457 1.057 1.029 1.057a.941.941 0 0 0 .266-.039l2.17 4.035c-.507.065-.913.51-.913 1.045 0 .587.457 1.057 1.028 1.057.343 0 .648-.17.825-.43l6.005.052a1.824 1.824 0 0 1-.178-.327z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ao)"
        fillRule="nonzero"
        d="M102.638 15.377l1.475-.124s.421.32.393.763c-.028.453-.435.546-.815.607-.379.062-1.56 0-1.952 0-.394 0-.506.196-.506.196s.225.35-.113.629c-.252.195-.688.195-.969.04-.281-.154-.52-.545-.155-.968.38-.453 1.293-.69 2.698-.587l-.056-.556z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ap)"
        fillRule="nonzero"
        d="M101.618 11.915l-1.557.184c-1.2-.61-2.216-.51-2.704-.24-.41.212-.898.708-1.07 1.232l.33-.056.265-.043c.382-.057.25-.085.382-.085.634 0 1.135.61 1.135 1.36 0 .752-.515 1.362-1.135 1.362-.119 0-.382-.085-.382-.085l-.277.042c.079.354.145.61.145.61-.132.637-.066 1.304.316 1.389.383.085.66-.213.66-.213l.224.213c.99-.085 1.966-.44 1.966-.44-.132-.269-.158-.652.066-1.049.356-.623 1.214-.95 2.533-.808l-.04-.75 1.386-.17s.304.325.356.821c1.175-1.105 1.465-2.197 1.465-2.197v-2.395c-2.77-.298-4.064 1.318-4.064 1.318z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aq)"
        fillRule="nonzero"
        d="M109.42 24.64s-.278.915-1.302 1.077l-1.262-.31 10.591 19.18c1.409-.323 2.326-1.239 2.326-1.239L109.42 24.64"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ar)"
        fillRule="nonzero"
        d="M49.606 50.986a.97.97 0 0 1 .175-.533l-6.334 7.25 1.031.964 6.014-6.804a.885.885 0 0 1-.886-.877z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__as)"
        fillRule="nonzero"
        d="M44.985 50.11c-.51 0-.93-.375-.93-.83l-1.066 3.962c-.045.16-.12.294-.24.428l-1.65 1.793 1.14.857 1.636-1.673c.195-.2.345-.442.435-.696l1.485-4.296a.918.918 0 0 1-.81.455z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__at)"
        fillRule="nonzero"
        d="M58.056 61.041v-.028l-15.783 2.158 3.405 1.26c.14.057.279.127.405.21l1.576 1.066 11.053-1.583v-.014a6.617 6.617 0 0 1-.656-3.069z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__au)"
        fillRule="nonzero"
        d="M51.393 49.28l-.9 1.208a.785.785 0 0 1 .639-.343c.443 0 .809.384.809.85a.873.873 0 0 1-.274.632s.43-.055 1.174-1.414l-1.448-.933z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__av)"
        fillRule="nonzero"
        d="M100.841 24.912c-1.062-1.54-3.773-5.179-6.238-5.833-3.146-.83-9.52-.231-15.336 5.124-5.816 5.356-10.024 9.566-10.624 10.166-.599.6-1.157 1.43-1.294 2.766-.136 1.336-.19 2.957-.558 3.285-.368.327-1.24.367-1.24.367s-.394.56-.926.777c-.53.232-1.88.695-1.88.695s-6.319 2.194-9.574 2.916c-3.255.723-4.454.3-6.919-1.321-2.451-1.622-5.611-6.05-5.747-7.168-.028-.177-.028-.341-.028-.505l-.204-.04c-.613.463-.232 1.349-.232 1.349s1.662 3.516 2.765 4.687c1.648 1.731 4.767 3.516 4.767 3.516l2.016 1.24 31.53-8.53 3.051-2.835a9.187 9.187 0 0 1 2.084-1.444l9.943-4.974s-.041-.395.081-.668a.103.103 0 0 1-.054.027c1.675-.899 3.228-1.771 4.372-2.507.408-.19.504-.709.245-1.09zm-14.846 8.844c.11-.055.205-.11.313-.164.11-.054.246-.122.395-.19-.15.068-.286.136-.395.19-.108.055-.204.11-.313.164zm1.076-.532c-.054.028-.095.041-.136.069.04-.028.095-.041.136-.069z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aw)"
        fillRule="nonzero"
        d="M5.956 48.069c-.198 0-.335-.218-.248-.421.77-1.792 2.06-3.652 3.686-5.376 0 0-1.96-.23-3.723.543-1.75.774-2.941 2.077-2.941 2.077s-.633 4.168-.832 5.145c-.198.977-.695 3.326-.72 3.624-.024.3.062.34.249.3.186-.055 1.948-1.019 2.097-1.128.161-.108.174-.597.174-.597s.558.04.67-.394c.112-.434.161-1.072.161-1.072s.372.109.571-.299c.199-.407.745-1.832.745-1.832l1.042-.57h-.93z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__ax)"
        fillRule="nonzero"
        d="M102.018 11.733l.515-.052c.214-.249.8-.576.8-.576v-.681l-.128-.799s.043-1.912-.186-2.462c-.229-.55-2.087-2.318-2.087-2.318.158-1.99-.157-2.933-.157-2.933C99.99 0 98.775 0 98.775 0c-1.501 1.021-2.245 3.575-2.445 5.46-.2 1.886.372 2.122.372 2.122s.372.17.957.105c.586-.066 1.816-.694 1.816-.694l.828-.904s.544.354 1.187.982c.643.642.7 1.114.7 1.114v1.492l-.172.747v1.31z"
      />
      <ellipse
        cx={92.765}
        cy={15.253}
        fill="url(#icon-motorcycle-on_svg__ay)"
        fillRule="nonzero"
        rx={1.174}
        ry={1.173}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__az)"
        fillRule="nonzero"
        d="M98.296 12.907c-.309 0-.602.076-.834.195a1.52 1.52 0 0 1 .448-.065c.742 0 1.329.467 1.329 1.043 0 .576-.603 1.043-1.329 1.043a1.52 1.52 0 0 1-.448-.065c.247.13.525.195.834.195.835 0 1.515-.532 1.515-1.184-.016-.63-.68-1.162-1.515-1.162z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aA)"
        fillRule="nonzero"
        d="M97.453 14.08a1.26 1.26 0 0 0-.537.117l-2.977.363c.537 0 .976.427.976.96 0 .437-.292.79-.707.907l2.842-.32c.122.032.257.064.39.064.66 0 1.196-.47 1.196-1.046 0-.576-.524-1.045-1.183-1.045z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aB)"
        fillRule="nonzero"
        d="M109.182 13.277c-.765-.148-2.28-.296-3.044-.37v.469c.98.062 3.13.296 3.679.506.779.297 1.154.73 1.082 1.655 0 0-.015-.654-.866-.852-1.471-.32-3.852.519-3.852.519s.116-.346.116-.519c0-.173-.16-.395-.75-.21a4.99 4.99 0 0 1-.982.914.97.97 0 0 1 .015.21 1.486 1.486 0 0 1-.072.309c.13.062.303.099.519.037.505-.124.88-.333.88-.333s.923 1.173 1.068 1.383c0 0-.765-.297-2.006-.074l.65.679c.678-.05 1.702-.05 1.933.333.187.31.23.593.23.779.073.074.13.148.174.222.36.803.1 1.556.1 1.556l.26.358.707.272s2.366-3.841 2.525-5.57c.1-1.692-1.313-2.075-2.366-2.273zm-.303 5.966c-.202-2.088-2.034-3.607-2.034-3.607s3-.938 3.332-.11c.448 1.11-1.298 3.717-1.298 3.717z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aC)"
        fillRule="nonzero"
        d="M116.996 28.588l-.317.317a.34.34 0 0 0 .317-.317z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aD)"
        fillRule="nonzero"
        d="M116.992 17.6l-.742.085s.18 6.34 0 11.578c.09.028.199.042.298.056.245.014.751.014.751.014.253-3.966.054-9.749-.009-11.341-.018-.238-.145-.405-.298-.391z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aE)"
        fillRule="nonzero"
        d="M104.894 22.61c0-.628.621-1.296 1.242-1.51.5-.174 1.516-.227 1.894-.254l-1.485-2.073s-2.227 0-3.212 1.511l1.03 1.712s-.545.454-.06 1.47l.712-.307a1.49 1.49 0 0 1-.121-.548z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aF)"
        fillRule="nonzero"
        d="M107.856 19.134c-.217-.505-1.204-.818-1.893-.974l-1.555-1.733a1.262 1.262 0 0 1-.487.156c-.365.072-1.5 0-1.879 0s-.487.229-.487.229.217.409-.108.734c-.122.12-.284.168-.46.18 0 0-.027.542.095.734.122.193.865.951.865.951.203-.084.568-.06.65 0 .08.06.54.53.54.53-.324.204-.419.662-.419.662l.42.517c.486-.265.973-.457.973-.457.878-1.36 2.866-1.36 2.866-1.36l.96 1.36c0-.012.257-.758-.081-1.529z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aG)"
        fillRule="nonzero"
        d="M95.114 44.587c-.646 0-1.175.528-1.175 1.173s.53 1.173 1.175 1.173 1.174-.528 1.174-1.173a1.162 1.162 0 0 0-1.174-1.173zm0 1.663a.49.49 0 1 1-.001-.98.49.49 0 0 1 0 .98z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aH)"
        fillRule="nonzero"
        d="M89.242 41.067c-.645 0-1.174.528-1.174 1.173s.53 1.173 1.174 1.173c.646 0 1.175-.528 1.175-1.173a1.17 1.17 0 0 0-1.175-1.173zm0 1.663a.49.49 0 1 1 0-.98.49.49 0 0 1 0 .98z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aI)"
        fillRule="nonzero"
        d="M107.972 41.934l-6.33 12.928a.506.506 0 0 1-.637.25l-2.369-.93 6.995-14.289 2.161 1.389a.492.492 0 0 1 .18.652z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aJ)"
        fillRule="nonzero"
        d="M99.498 59.271c-.325 1.147-1.656 4.502-3.095 7.6 0 0-.326 1.476-1.004 2.752-.706 1.32-1.344 1.821-1.344 1.821-.285.459-.543.846-.774 1.133-1.412 1.706-4.073 2.294-5.213 2.466 0 0 4.385.516 7.032-1.75 2.647-2.265 3.692-6.537 4.045-9.018.353-2.48.666-6.782.666-6.782a7.935 7.935 0 0 1-.313 1.778z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aK)"
        fillRule="nonzero"
        d="M107.525 24.63a.354.354 0 0 1-.161 0c-.322-.06-1.523-.295-1.875-.418-.41-.148-.981-.887-.981-1.466s.6-1.195 1.2-1.392c.528-.172 1.656-.222 1.92-.234a.38.38 0 0 1 .117.012l.527.148a.483.483 0 0 1 .22.136c.16.184.498.59.688 1.034.03.05.03.111.015.173-.073.37-.396 1.663-1.67 2.008z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aL)"
        fillRule="nonzero"
        d="M109.24 24.64c.019 0 .028 0 .048-.012.827-.346 1.048-1.643 1.087-2.001a.505.505 0 0 0-.01-.173c-.135-.432-.356-.852-.452-1.038a.333.333 0 0 0-.144-.135l-.347-.149c-.019-.012-.029-.012-.048-.012-.01.037-.26 1.618-.135 3.52z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aM)"
        fillRule="nonzero"
        d="M87.832 73.156c-.124-.012-2.388.167-2.761.103-.373-.064-.608-.474-2.237-.512-1.505.153-1.96.87-1.96.87l-.18.167c.193.166.345.32.387.397.152.346-.18.64-.456.768s-1.45.103-1.45.103h-1.339c-.4 0-.746-.167-.884-.308 0 0-.345.064-.87-.32-.4-.294-1.104-.845-1.45-1.242l-6.53-.051a1.154 1.154 0 0 1-1.615.166l-.194.052.525.845c-.856.742-1.74.845-1.74.845l-.704-1.14c-.828-.18-2.278-.781-2.278-.781.07.243.138.679-.069 1.165-.262.602-.594 1.038-.966 1.255 0 0 2.195 1.23 5.15 1.23 0 0 .11.192.51.192s1.423-.09 2.776 0c1.353.09 3.355.422 4.625.14 0 0 3.286.065 5.219.231 1.933.167 2.527.18 2.734-.23 0 0 4.059-1.23 5.578-1.383 0 0 .4-.141.414-1.268.014-1.127-.097-1.28-.235-1.294z"
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aN)"
        fillRule="nonzero"
        d="M111.842 34.04s-.458.396-1.158.6c-.442.128-1 .154-1.057-.089-.057-.255.258-.344.258-.344l-1.486-2.527-1.543 3.203s1.214 1.123 2.757.957l.372.357a.64.64 0 0 0 .714.115l2.028-.88-.885-1.391z"
      />
      <ellipse
        cx={76.326}
        cy={58.667}
        fill="url(#icon-motorcycle-on_svg__aO)"
        fillRule="nonzero"
        rx={5.871}
        ry={5.867}
      />
      <ellipse
        cx={76.326}
        cy={58.667}
        fill="url(#icon-motorcycle-on_svg__aP)"
        fillRule="nonzero"
        rx={2.348}
        ry={2.347}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aQ)"
        fillRule="nonzero"
        d="M68.322 70.4h6.267l.563-.668-9.394-4.025z"
      />
      <ellipse
        cx={67.519}
        cy={70.987}
        fill="url(#icon-motorcycle-on_svg__aR)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={63.996}
        cy={65.12}
        fill="url(#icon-motorcycle-on_svg__aS)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <ellipse
        cx={85.133}
        cy={61.6}
        fill="url(#icon-motorcycle-on_svg__aT)"
        fillRule="nonzero"
        rx={2.936}
        ry={2.933}
      />
      <ellipse
        cx={85.72}
        cy={62.187}
        fill="url(#icon-motorcycle-on_svg__aU)"
        fillRule="nonzero"
        rx={1.174}
        ry={1.173}
      />
      <ellipse
        cx={85.133}
        cy={61.6}
        fill="url(#icon-motorcycle-on_svg__aV)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aW)"
        fillRule="nonzero"
        d="M41.098 46.006l.798-1.075a.89.89 0 0 1 1.13-.237c.435.247.56.8.248 1.184l-.829 1.055c-.01.01-.725-.65-1.347-.927z"
      />
      <ellipse
        cx={41.686}
        cy={46.347}
        fill="url(#icon-motorcycle-on_svg__aX)"
        fillRule="nonzero"
        rx={1}
        ry={1}
      />
      <path
        fill="url(#icon-motorcycle-on_svg__aY)"
        fillRule="nonzero"
        d="M63.41 53.982l-15.564-9.287s-3.14-1.753-4.8-3.453c-1.11-1.137-2.783-4.603-2.783-4.603s-.411-.923.288-1.365c-.288-.522-1.577-1.459-2.167-1.204-.603.254-1.07.843-.644 2.248.398 1.351 3.346 6.236 4.594 6.972.822.495 19.814 11.857 19.814 11.857l1.261-1.165z"
      />
      <path d="M0-6h155v94H0z" />
    </g>
  </svg>
);

export default SvgIconMotorcycleOn;
